// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wNAZS","label":"styles_label__36xut"};